export const PickupLocation = {
    Loader: {
        Text: {
            locating: 'Locating satellites..'
        }
    },
    Errors: {
        Messages: {
            geolocationDenied: 'Curb-it does not have permission to use your location.'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/PickupLocation.ts